import { getCookie } from "./cookies";
const fetcher = (path, props = {}, isNew = false) => {
  return fetch('/apiv2' + path, {
    ...props,
    headers: { 'Content-Type': 'application/json',
    elektraAuthEmployee: getCookie('elektraAuthEmployee')
  }
  }).then((response) => response.json());
};

export default fetcher;
